export function arrayBufferToBase64(arrayBuffer) {
    var byteArray = new Uint8Array(arrayBuffer);
    var byteString = '';
    for (var i = 0; i < byteArray.byteLength; i++) {
        byteString += String.fromCharCode(byteArray[i]);
    }
    var b64 = window.btoa(byteString);

    return b64;
}

function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
        return ('0' + (byte & 0xFF).toString(16)).slice(-2);
    }).join('')
}

export function base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

function mergeTypedArrays(a, b) {
    // Checks for truthy values on both arrays
    if (!a && !b) throw 'Please specify valid arguments for parameters a and b.';

    // Checks for truthy values or empty arrays on each argument
    // to avoid the unnecessary construction of a new array and
    // the type comparison
    if (!b || b.length === 0) return a;
    if (!a || a.length === 0) return b;

    // Make sure that both typed arrays are of the same type
    if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b))
        throw 'The types of the two arguments passed for parameters a and b do not match.';

    var c = new a.constructor(a.length + b.length);
    c.set(a);
    c.set(b, a.length);

    return c;
}

export function generateRSAKey() {
    return window.crypto.subtle.generateKey(
        {
            name: "RSA-OAEP",
            modulusLength: 4096,
            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
            hash: {name: "SHA-256"},
        },
        true,
        ["encrypt", "decrypt"]
    )
}

export function exportRSAPrivateKey(key) {
    return window.crypto.subtle.exportKey(
        "pkcs8",
        key
    )
}

export function exportRSAPublicKey(key) {
    return window.crypto.subtle.exportKey(
        "spki",
        key
    )
}

function importRSAPrivateKey(pem) {
    return window.crypto.subtle.importKey(
        "pkcs8",
        base64ToArrayBuffer(pem),
        {
            name: "RSA-OAEP",
            hash: "SHA-256"
        },
        false,
        ["decrypt"]
    );
}

function importRSAPublicKey(pem) {
    return window.crypto.subtle.importKey(
        "spki",
        base64ToArrayBuffer(pem),
        {
            name: "RSA-OAEP",
            hash: "SHA-256"
        },
        false,
        ["encrypt"]
    );
}

async function deriveAESKey(password) {
    let enc = new TextEncoder();
    let material = await window.crypto.subtle.importKey(
        "raw",
        enc.encode(password),
        "PBKDF2",
        false,
        ["deriveBits", "deriveKey"]
    );
    return window.crypto.subtle.deriveKey(
        {
            "name": "PBKDF2",
            salt: base64ToArrayBuffer("9108FDrCt58x78sC6JMDAJJdLgW2XXRBRq/SdKkny+0="),
            "iterations": 12000,
            "hash": "SHA-256"
        },
        material,
        {"name": "AES-CBC", "length": 256},
        false,
        ["encrypt", "decrypt"]
    );
}

function importAESKey(rawKey) {
    return window.crypto.subtle.importKey(
        "raw",
        rawKey,
        "AES-CBC",
        false,
        ["encrypt", "decrypt"]
    );
}

export async function generateAESKey() {
    let key = await window.crypto.subtle.generateKey(
        {
            name: "AES-CBC",
            length: 256,
        },
        true,
        ["encrypt", "decrypt"]
    );
    return window.crypto.subtle.exportKey(
        "raw",
        key
    )
}

export async function decryptTable(aesKey, tableData) {
    let ommit = ["id", "deleted_date", "updated_date", "created_date"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < tableData.length; i++) {
        let current = tableData[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (!ommit.includes(prop) && current[prop] !== "") {
                    current[prop] = await decryptEntry(key, current[prop]);
                }
            }
        }
        tableData[i] = current;
    }
    return tableData;
}

export async function decryptData(aesKey, tableData, decryptKeys = []) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < tableData.length; i++) {
        let current = tableData[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (decryptKeys.includes(prop) && current[prop] !== "") {
                    current[prop] = await decryptEntry(key, current[prop]);
                }
            }
        }
        tableData[i] = current;
    }
    return tableData;
}

export async function decryptMessages(aesKey, messages) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < messages.length; i++) {
        let current = messages[i];
        try {
            if (current.data.text !== null && current.data.text.startsWith("#")) {
                current.data.text = current.data.text.substring(1);
            }
            current.data.text = await decryptEntry(key, current.data.text);
            current.data.text = current.data.text.replace('\r\n', '\n');
        } catch (e) {

        }
        let res = JSON.parse(sessionStorage.getItem(current.data.meta_id));
        if (res !== null) {
            current.data.meta_name = res.full_name;
        }
        messages[i] = current;
    }
    return messages;
}

export async function encryptUser(aesKey, user) {
    let ommit = ["id", "deleted_date", "updated_date", "created_date"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let result = {
        id: user.id
    };
    for (let prop in user) {
        if (Object.prototype.hasOwnProperty.call(user, prop)) {
            if (!ommit.includes(prop)) {
                if (prop === "username" && user[prop] === "") {
                    result["username"] = "";
                } else {
                    result[prop] = await encryptEntry(key, user[prop]);
                }
            }
        }
    }

    return result;
}

export async function encryptData(aesKey, tableData, encryptKeys = []) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < tableData.length; i++) {
        let current = tableData[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (encryptKeys.includes(prop) && current[prop] !== "") {
                    current[prop] = await encryptEntry(key, current[prop]);
                }
            }
        }
        tableData[i] = current;
    }
    return tableData;
}

export async function encryptAES(aesKey, message) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

export async function encryptAESWithPw(password, message) {
    let key = await deriveAESKey(password);
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

async function encryptAESWithPwFixedIV(password, message) {
    let key = await deriveAESKey(password);
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = new Uint8Array([249, 208, 199, 136, 172, 221, 205, 33, 9, 10, 46, 174, 147, 220, 188, 211]);
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

export async function decryptAES(aesKey, message) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    if (message !== null && message.startsWith("#")) {
        message = message.substring(1);
    }
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    let res = new TextDecoder("utf-8").decode(new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    )));
    return res;
}

export async function decryptFile(aesKey, file) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let encryptedBytes = file;
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    return new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    ));
}

export async function encryptFile(aesKey, file) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let encodedBytes = file;
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return mergeTypedArrays(iv, new Uint8Array(encrypted));
}

async function decryptEntry(key, message) {
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    let res = new TextDecoder("utf-8").decode(new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    )));
    return res;
}

export async function encryptEntry(key, message) {
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

export async function decryptAESWithPw(password, message) {
    let key = await deriveAESKey(password);
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    let res = new TextDecoder("utf-8").decode(new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    )));
    return res;
}

export async function encryptRSA(pub, message) {
    let key = await importRSAPublicKey(pub);
    let encryptedBytes = new Uint8Array(message);
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "RSA-OAEP",
        },
        key,
        encryptedBytes
    );
    return arrayBufferToBase64(new Uint8Array(encrypted));
}

export async function decryptRSA(priv, message) {
    let key = await importRSAPrivateKey(priv);
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let encrypted = await window.crypto.subtle.decrypt(
        {
            name: "RSA-OAEP",
        },
        key,
        encryptedBytes
    );
    return new Uint8Array(encrypted);
}

export async function savePair(key, value) {
    let pair1 = await encryptAESWithPwFixedIV("PvpZGXsKvU", key);
    let pair2 = await encryptAESWithPw("PvpZGXsKvU", value);
    return [pair1, pair2];
}

export async function getKey(key) {
    return await encryptAESWithPwFixedIV("PvpZGXsKvU", key);
}

export async function getValue(value) {
    return  await decryptAESWithPw("PvpZGXsKvU", value);
}

export function getUid() {
    let a = new Uint32Array(3);
    window.crypto.getRandomValues(a);
    return (performance.now().toString(36)+Array.from(a).map(A => A.toString(36)).join("")).replace(/\./g,"");
}
